var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotFound = function SvgNotFound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 740,
    height: 417,
    viewBox: "0 0 740 417",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M585.467 139.074C542.512 103.061 471.734 117.498 422.012 128.772C391.814 135.617 361.289 142.905 330.182 143.541C301.265 144.131 279.072 135.967 253.315 124.393C237.139 117.124 225.176 105.639 209.909 97.0866C194.165 88.2644 177.611 80.6062 159.859 76.8907C129.33 70.5005 104.752 79.3497 90.6575 107.154C77.1217 133.855 74.6435 165.178 76.4356 194.624C77.5379 212.727 80.5519 231.223 85.8244 248.948C102.798 305.986 155.45 344.948 214.966 344.948H619.738C632.719 329.743 640.921 312.087 645.122 292.605C657.286 236.199 629.686 176.147 585.467 139.074Z",
    fill: "url(#paint0_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320.281 358.823L378.479 372.312",
    stroke: "#EECFF8",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M381.562 372.313L361.135 361.521",
    stroke: "#EECFF8",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M348.031 373.083L287.521 374.625",
    stroke: "#EECFF8",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M364.284 373.099C365.028 373.099 365.028 371.942 364.284 371.942C363.54 371.942 363.536 373.099 364.284 373.099Z",
    fill: "#EECFF8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M385.316 368.231C386.06 368.231 386.06 367.075 385.316 367.075C384.572 367.075 384.568 368.231 385.316 368.231Z",
    fill: "#EECFF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M385.509 374.459C386.253 374.459 386.253 373.303 385.509 373.303C384.765 373.303 384.765 374.459 385.509 374.459Z",
    fill: "#EECFF8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M275.677 373.877C276.421 373.877 276.421 372.721 275.677 372.721C274.933 372.721 274.933 373.877 275.677 373.877Z",
    fill: "#EECFF8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M329.428 350.702C330.171 350.702 330.171 349.546 329.428 349.546C328.684 349.546 328.68 350.702 329.428 350.702Z",
    fill: "#EECFF8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M304.109 339.02C304.853 339.02 304.853 337.864 304.109 337.864C303.365 337.864 303.365 339.02 304.109 339.02Z",
    fill: "#EECFF8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M471.75 372.505H521.083",
    stroke: "#EECFF8",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M529.177 372.505H629.385",
    stroke: "#EECFF8",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M498.922 367.495H539.776",
    stroke: "#EECFF8",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M576.098 348.887C576.098 348.887 577.393 351.045 584.731 351.477C592.069 351.908 592.069 358.815 596.386 358.815C600.703 358.815 598.544 354.93 596.818 353.203C595.091 351.477 591.638 348.455 591.638 348.455C591.638 348.455 586.026 347.16 584.299 345.002C582.573 342.843 577.824 341.117 577.824 341.117L576.098 348.887Z",
    fill: "#FB8F8F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M576.098 348.887C576.098 348.887 577.393 351.045 584.731 351.477C592.069 351.908 592.069 358.815 596.386 358.815C600.703 358.815 598.544 354.93 596.818 353.203C595.091 351.477 591.638 348.455 591.638 348.455C591.638 348.455 586.026 347.16 584.299 345.002C582.573 342.843 577.824 341.117 577.824 341.117L576.098 348.887Z",
    fill: "url(#paint1_radial)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M576.098 348.887C576.098 348.887 577.393 351.045 584.731 351.477C592.069 351.908 592.069 358.815 596.386 358.815C600.703 358.815 598.544 354.93 596.818 353.203C595.091 351.477 591.638 348.455 591.638 348.455C591.638 348.455 586.026 347.16 584.299 345.002C582.573 342.843 577.824 341.117 577.824 341.117L576.098 348.887Z",
    fill: "url(#paint2_radial)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M529.474 339.818C529.474 339.818 527.747 344.567 523.862 349.315C523.862 349.315 521.704 350.61 525.157 352.768C528.61 354.927 533.359 357.085 533.79 360.97C533.79 360.97 534.222 362.697 532.064 363.128C529.905 363.56 526.452 361.402 526.452 361.402C526.452 361.402 522.999 357.948 519.545 356.222C516.092 354.495 512.639 352.768 512.639 350.61C512.639 348.452 516.524 341.977 516.524 341.977C516.524 341.977 526.02 333.343 529.474 339.818Z",
    fill: "#FB8F8F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M529.474 339.818C529.474 339.818 527.747 344.567 523.862 349.315C523.862 349.315 521.704 350.61 525.157 352.768C528.61 354.927 533.359 357.085 533.79 360.97C533.79 360.97 534.222 362.697 532.064 363.128C529.905 363.56 526.452 361.402 526.452 361.402C526.452 361.402 522.999 357.948 519.545 356.222C516.092 354.495 512.639 352.768 512.639 350.61C512.639 348.452 516.524 341.977 516.524 341.977C516.524 341.977 526.02 333.343 529.474 339.818Z",
    fill: "url(#paint3_radial)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M529.474 339.818C529.474 339.818 527.747 344.567 523.862 349.315C523.862 349.315 521.704 350.61 525.157 352.768C528.61 354.927 533.359 357.085 533.79 360.97C533.79 360.97 534.222 362.697 532.064 363.128C529.905 363.56 526.452 361.402 526.452 361.402C526.452 361.402 522.999 357.948 519.545 356.222C516.092 354.495 512.639 352.768 512.639 350.61C512.639 348.452 516.524 341.977 516.524 341.977C516.524 341.977 526.02 333.343 529.474 339.818Z",
    fill: "url(#paint4_radial)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M551.87 322.417C545.615 322.952 539.321 322.124 533.351 320.174C526.548 317.95 514.126 315.009 502.703 318.235C493.11 320.941 487.579 326.591 481.562 331.112C475.284 335.825 467.421 337.914 459.617 337.047L454.579 336.488C454.117 336.438 453.843 336.993 454.167 337.328C455.689 338.897 460.361 341.626 473.777 339.39C491.911 336.369 497.954 328.599 497.954 328.599C497.954 328.599 498.386 336.369 496.228 340.254C494.069 344.139 488.026 350.614 488.026 350.614L492.774 363.132C492.774 363.132 495.796 364.427 500.113 363.132L501.408 361.837C501.408 361.837 501.839 358.384 498.818 357.952C498.818 357.952 496.659 357.089 497.954 353.204C499.249 349.319 501.408 348.024 510.904 348.024C520.401 348.024 524.721 341.549 524.721 341.549C524.721 341.549 532.923 341.98 538.539 346.729C544.15 351.477 559.694 357.089 568.759 354.067C568.759 354.067 572.644 357.952 573.076 360.974C573.507 363.995 573.939 365.722 578.687 365.29C578.687 365.29 582.141 364.859 581.277 362.269C580.414 359.679 578.256 362.269 577.392 358.815C576.529 355.362 576.097 351.477 576.097 351.477C576.097 351.477 582.141 349.319 581.277 338.959C580.414 328.599 584.731 322.983 590.774 323.847C596.817 324.71 602.861 325.573 602.861 325.573C602.861 325.573 608.041 327.3 613.652 323.415C619.264 319.53 620.127 317.372 620.127 317.372L619.696 315.213C619.696 315.213 605.015 309.602 603.289 308.307C601.562 307.012 595.519 301.4 595.519 301.4C595.519 301.4 579.111 301.4 575.226 305.285C571.341 309.17 565.73 318.667 560.114 320.829C557.998 321.642 555.004 322.151 551.87 322.417Z",
    fill: "#FB8F8F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M566.062 316.288C566.062 316.288 573.728 326.216 584.088 327.08L581.632 331.724C581.632 331.724 568.979 329.238 563.14 319.021L566.062 316.288Z",
    fill: "url(#paint5_radial)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M551.87 322.417C545.615 322.952 539.321 322.124 533.351 320.174C526.548 317.95 514.126 315.009 502.703 318.235C493.121 320.937 487.594 326.575 481.586 331.092C475.296 335.821 467.406 337.914 459.582 337.043L454.579 336.488C454.117 336.438 453.843 336.993 454.167 337.328C455.689 338.897 460.361 341.626 473.777 339.39C491.911 336.369 497.954 328.599 497.954 328.599C497.954 328.599 498.386 336.369 496.228 340.254C494.069 344.139 488.026 350.614 488.026 350.614L492.774 363.132C492.774 363.132 495.796 364.427 500.113 363.132L501.408 361.837C501.408 361.837 501.839 358.384 498.818 357.952C498.818 357.952 496.659 357.089 497.954 353.204C499.249 349.319 501.408 348.024 510.904 348.024C520.401 348.024 524.721 341.549 524.721 341.549C524.721 341.549 532.923 341.98 538.539 346.729C544.15 351.477 559.694 357.089 568.759 354.067C568.759 354.067 572.644 357.952 573.076 360.974C573.507 363.995 573.939 365.722 578.687 365.29C578.687 365.29 582.141 364.859 581.277 362.269C580.414 359.679 578.256 362.269 577.392 358.815C576.529 355.362 576.097 351.477 576.097 351.477C576.097 351.477 582.141 349.319 581.277 338.959C580.414 328.599 584.731 322.983 590.774 323.847C596.817 324.71 602.861 325.573 602.861 325.573C602.861 325.573 608.041 327.3 613.652 323.415C619.264 319.53 620.127 317.372 620.127 317.372L619.696 315.213C619.696 315.213 605.015 309.602 603.289 308.307C601.562 307.012 595.519 301.4 595.519 301.4C595.519 301.4 579.111 301.4 575.226 305.285C571.341 309.17 565.73 318.667 560.114 320.829C557.998 321.642 555.004 322.151 551.87 322.417Z",
    fill: "url(#paint6_radial)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M510.908 348.023C515.336 348.023 518.639 346.617 520.902 345.11C519.726 344.3 518.462 343.614 517.094 343.09C513.317 341.633 509.085 341.402 505.077 341.171C501.423 340.963 497.927 341.124 494.697 342.604C492.042 346.301 488.022 350.61 488.022 350.61L492.77 363.128C492.77 363.128 495.792 364.423 500.109 363.128L501.404 361.833C501.404 361.833 501.835 358.38 498.814 357.948C498.814 357.948 496.655 357.085 497.95 353.2C499.245 349.315 501.411 348.023 510.908 348.023Z",
    fill: "url(#paint7_radial)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M577.393 358.815C577.115 357.705 576.884 356.557 576.695 355.501C574.745 355.354 572.802 355.886 571.288 357.127C572.128 358.334 572.895 359.729 573.072 360.974C573.504 363.995 573.935 365.722 578.684 365.29C578.684 365.29 582.137 364.859 581.274 362.269C580.418 359.679 578.256 362.269 577.393 358.815Z",
    fill: "url(#paint8_radial)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M603.297 308.302C603.035 308.106 602.672 307.809 602.248 307.451C601.678 307.609 601.111 307.774 600.549 307.956C595.496 309.59 590.25 312.253 587.722 317.167C586.5 319.549 585.98 322.185 585.756 324.86C587.194 323.935 588.901 323.58 590.774 323.846C596.818 324.71 602.861 325.573 602.861 325.573C602.861 325.573 608.041 327.3 613.653 323.415C619.264 319.53 620.128 317.371 620.128 317.371L619.696 315.213C619.704 315.209 605.023 309.597 603.297 308.302Z",
    fill: "url(#paint9_radial)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M594.59 306.595C594.467 307.273 594.139 307.894 593.703 308.429C592.593 309.79 590.204 313.818 591.214 322.547C592.509 333.771 580.854 334.634 579.127 327.296C577.874 321.969 578.441 314.824 578.846 311.305C579.004 309.944 579.821 308.757 581.031 308.117C585.375 305.816 595.607 300.933 594.59 306.595Z",
    fill: "url(#paint10_radial)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M598.98 307.439H599.843L602.865 308.302L604.16 310.461L601.57 313.051L598.98 313.914C596.39 310.892 598.98 307.439 598.98 307.439Z",
    fill: "url(#paint11_radial)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M620.135 317.367L619.704 315.209C619.704 315.209 619.179 315.009 618.316 314.673C618.316 314.673 614.955 315.641 615.387 317.367C615.668 318.497 617.611 318.886 618.921 319.021C619.904 317.942 620.135 317.367 620.135 317.367Z",
    fill: "url(#paint12_radial)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M599.412 312.404C600.009 312.404 600.491 311.63 600.491 310.677C600.491 309.723 600.009 308.95 599.412 308.95C598.814 308.95 598.333 309.723 598.333 310.677C598.333 311.63 598.814 312.404 599.412 312.404Z",
    fill: "url(#paint13_radial)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M601.354 322.335C601.354 322.335 602.649 324.494 606.534 325.357",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M593.8 321.688C592.166 317.957 592.081 313.718 593.8 308.299C593.765 308.341 593.738 308.391 593.703 308.434C592.593 309.794 590.204 313.822 591.214 322.552C591.267 323.029 591.291 323.48 591.302 323.92C592.713 324.12 594.112 324.321 595.426 324.509C594.571 323.43 594.062 322.282 593.8 321.688Z",
    fill: "url(#paint14_radial)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M568.759 354.067C566.601 351.477 566.601 349.75 566.601 349.75C567.896 344.57 566.601 342.844 566.601 342.844C566.601 347.16 564.443 349.319 564.443 349.319C564.443 349.319 553.651 353.635 545.014 344.57C536.381 335.505 535.517 334.642 535.517 334.642C529.474 334.642 524.726 341.549 524.726 341.549L525.196 341.587C527.007 341.761 533.725 342.655 538.543 346.729C544.151 351.477 559.694 357.089 568.759 354.067Z",
    fill: "url(#paint15_radial)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M611.772 320.065C612.331 320.065 612.331 319.198 611.772 319.198C611.217 319.198 611.213 320.065 611.772 320.065Z",
    fill: "#0061FE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M610.138 322.647C610.512 322.647 610.512 322.069 610.138 322.069C609.764 322.069 609.764 322.647 610.138 322.647Z",
    fill: "#0061FE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M608.719 320.794C609.093 320.794 609.093 320.216 608.719 320.216C608.349 320.216 608.346 320.794 608.719 320.794Z",
    fill: "#0061FE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M605.667 320.54C605.852 320.54 605.852 320.25 605.667 320.25C605.478 320.25 605.478 320.54 605.667 320.54Z",
    fill: "#0061FE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M612.099 321.85C612.284 321.85 612.284 321.561 612.099 321.561C611.914 321.561 611.914 321.85 612.099 321.85Z",
    fill: "#0061FE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M562.5 318.015C563.452 318.015 564.227 317.242 564.227 316.288C564.227 315.335 563.452 314.562 562.5 314.562C561.548 314.562 560.773 315.335 560.773 316.288C560.773 317.242 561.548 318.015 562.5 318.015Z",
    stroke: "#0144B9",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M563.907 317.291L564.508 317.846",
    stroke: "#0144B9",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M566.755 325.484C566.755 325.484 571.765 331.266 578.703 332.036",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M590.266 322.401C590.266 322.401 590.651 327.797 587.953 329.724",
    stroke: "#F1D23C",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M510.099 346.682C510.099 346.682 519.349 346.682 523.203 341.287",
    stroke: "#F1D23C",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M540.932 346.682C540.932 346.682 547.87 352.078 556.349 352.849",
    stroke: "#EECFF8",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M496.031 116.01H437.062V151.083H496.031V116.01Z",
    stroke: "#DEF4FF",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M492.562 111.771H433.594V146.844H492.562V111.771Z",
    fill: "url(#paint16_radial)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M501.62 103.099C513.329 103.099 522.818 93.6085 522.818 81.901C522.818 70.1936 513.329 60.7031 501.62 60.7031C489.911 60.7031 480.422 70.1936 480.422 81.901C480.422 93.6085 489.911 103.099 501.62 103.099Z",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M506.245 103.099C517.954 103.099 527.443 93.6085 527.443 81.901C527.443 70.1936 517.954 60.7031 506.245 60.7031C494.536 60.7031 485.047 70.1936 485.047 81.901C485.047 93.6085 494.536 103.099 506.245 103.099Z",
    fill: "#DEF4FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M498.343 99.0522H452.864V121.406H498.343V99.0522Z",
    fill: "#FFDE99"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M498.343 99.0522H452.864V121.406H498.343V99.0522Z",
    fill: "url(#paint17_radial)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M475.411 110.422L452.864 99.3411V121.406H498.343V99.1484L475.411 110.422Z",
    fill: "url(#paint18_radial)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M503.161 93.8491H457.682V116.203H503.161V93.8491Z",
    fill: "#FFDE99"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M480.229 105.219L457.682 94.138V116.203H503.161V93.9453L480.229 105.219Z",
    fill: "url(#paint19_radial)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M499.114 100.979H508.75",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M499.114 103.099H508.75",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M499.114 105.412H508.75",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M472.906 126.802H421.26V131.042H472.906V126.802Z",
    fill: "url(#paint20_radial)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M472.906 133.354H421.26V137.594H472.906V133.354Z",
    fill: "url(#paint21_radial)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M506.245 81.9282C508.8 81.9282 510.87 79.8574 510.87 77.3032C510.87 74.7491 508.8 72.6782 506.245 72.6782C503.689 72.6782 501.62 74.7491 501.62 77.3032C501.62 79.8574 503.689 81.9282 506.245 81.9282Z",
    fill: "#0061FE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M516.038 91.1239C514.597 86.8882 510.754 83.855 506.245 83.855C501.735 83.855 497.893 86.8844 496.451 91.1239H516.038Z",
    fill: "#0061FE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M565.406 119.865H528.406V111.385L524.552 103.292H528.406V94.8125H565.406V119.865Z",
    fill: "#0061FE"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M544.979 98.6668H581.979V90.1877L585.833 82.0939H581.979V73.6147H544.979V98.6668Z",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M547.87 77.6616C548.509 77.6616 549.026 77.144 549.026 76.5054C549.026 75.8667 548.509 75.3491 547.87 75.3491C547.23 75.3491 546.713 75.8667 546.713 76.5054C546.713 77.144 547.23 77.6616 547.87 77.6616Z",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M546.521 110.229C548.012 110.229 549.219 109.021 549.219 107.531C549.219 106.041 548.012 104.833 546.521 104.833C545.029 104.833 543.823 106.041 543.823 107.531C543.823 109.021 545.029 110.229 546.521 110.229Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M537.271 110.229C538.762 110.229 539.969 109.021 539.969 107.531C539.969 106.041 538.762 104.833 537.271 104.833C535.779 104.833 534.573 106.041 534.573 107.531C534.573 109.021 535.779 110.229 537.271 110.229Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M555.771 110.229C557.262 110.229 558.469 109.021 558.469 107.531C558.469 106.041 557.262 104.833 555.771 104.833C554.279 104.833 553.073 106.041 553.073 107.531C553.073 109.021 554.279 110.229 555.771 110.229Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M545.222 138.858C541.626 136.769 537.178 136.8 533.609 138.943C530.044 141.082 525.596 141.116 521.997 139.027L521.711 138.862C518.115 136.773 513.668 136.804 510.099 138.946C506.534 141.086 502.086 141.12 498.486 139.031L498.201 138.866C494.605 136.777 490.157 136.807 486.588 138.95",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M576.391 63.0156C579.582 63.0156 582.172 60.4272 582.172 57.2344C582.172 54.0416 579.582 51.4531 576.391 51.4531C573.199 51.4531 570.609 54.0416 570.609 57.2344C570.609 60.4272 573.199 63.0156 576.391 63.0156Z",
    stroke: "#FA404B",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M561.552 121.792H566.948V116.396",
    stroke: "#FA404B",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M184.09 251.315C184.09 251.315 178.918 249.792 173.426 249.816C171.19 249.823 169.04 248.979 167.448 247.407C166.804 246.771 166.145 245.934 165.594 245.167C164.792 244.057 163.235 243.83 162.152 244.666C155.828 249.569 137.32 265.147 138.754 278.456C138.85 279.35 139.964 279.708 140.565 279.038C143.051 276.274 149.353 269.884 162.935 259.081C162.935 259.081 172.431 259.081 178.047 263.398C183.662 267.714 184.09 251.315 184.09 251.315Z",
    fill: "#FFDE99"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M184.09 251.315C184.09 251.315 178.918 249.792 173.426 249.816C171.19 249.823 169.04 248.979 167.448 247.407C166.804 246.771 166.145 245.934 165.594 245.167C164.792 244.057 163.235 243.83 162.152 244.666C155.828 249.569 137.32 265.147 138.754 278.456C138.85 279.35 139.964 279.708 140.565 279.038C143.051 276.274 149.353 269.884 162.935 259.081C162.935 259.081 172.431 259.081 178.047 263.398C183.662 267.714 184.09 251.315 184.09 251.315Z",
    fill: "url(#paint22_radial)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M293.749 244.408C293.749 244.408 262.234 283.694 241.51 293.194C241.51 293.194 179.774 270.312 173.295 262.111C173.295 262.111 175.885 250.456 181.497 249.161C187.108 247.866 220.135 254.125 233.52 268.805C233.52 268.805 249.064 212.249 268.489 207.501C287.922 202.745 293.749 244.408 293.749 244.408Z",
    fill: "#0144B9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M293.749 244.408C293.749 244.408 262.234 283.694 241.51 293.194C241.51 293.194 179.774 270.312 173.295 262.111C173.295 262.111 175.885 250.456 181.497 249.161C187.108 247.866 220.135 254.125 233.52 268.805C233.52 268.805 249.064 212.249 268.489 207.501C287.922 202.745 293.749 244.408 293.749 244.408Z",
    fill: "#EC1659"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M384.411 352.34C384.411 352.34 391.317 358.815 394.339 363.995C395.326 365.683 395.942 366.959 396.328 367.915C397.804 371.565 402.109 373.226 405.57 371.353C406.954 370.605 428.472 359.879 437.382 345.403C437.787 344.747 437.159 343.795 436.45 344.092C430.171 346.728 423.685 348.891 415.059 352.34C404.792 356.449 399.084 348.023 393.904 341.548C388.727 335.07 384.411 352.34 384.411 352.34Z",
    fill: "#FFDE99"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M384.411 352.34C384.411 352.34 391.317 358.815 394.339 363.995C395.326 365.683 395.942 366.959 396.328 367.915C397.804 371.565 402.109 373.226 405.57 371.353C406.954 370.605 428.472 359.879 437.382 345.403C437.787 344.747 437.159 343.795 436.45 344.092C430.171 346.728 423.685 348.891 415.059 352.34C404.792 356.449 399.084 348.023 393.904 341.548C388.727 335.07 384.411 352.34 384.411 352.34Z",
    fill: "url(#paint23_radial)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M304.109 200.37C304.109 200.37 347.283 271.175 363.255 291.032C379.231 310.892 396.929 341.545 396.929 341.545C396.929 341.545 385.706 357.089 382.68 355.794C379.658 354.499 380.522 354.067 380.09 351.477C379.658 348.887 319.649 285.856 309.285 268.585C298.925 251.315 295.903 250.02 295.903 250.02C295.903 250.02 259.208 237.501 257.481 213.324C255.755 189.147 277.773 187.852 277.773 187.852L304.109 200.37Z",
    fill: "#EC1659"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M315.552 226.922L348.794 277.003",
    stroke: "#DEF4FF",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M349.01 301.396C332.603 291.036 329.15 276.355 315.336 255.631C308.911 245.992 300.991 239.625 294.358 235.567C285.12 229.916 280.622 218.947 283.339 208.464C284.777 202.914 286.565 197.383 288.176 192.793L277.778 187.848C277.778 187.848 276.853 187.902 275.4 188.195L275.188 188.28L263.625 194.154C259.771 197.9 256.811 203.858 257.485 213.32C259.212 237.498 295.908 250.016 295.908 250.016C295.908 250.016 298.929 251.311 309.289 268.581C319.649 285.852 379.662 348.883 380.094 351.473C380.526 354.063 379.662 354.495 382.684 355.79C384.133 356.41 387.475 353.153 390.558 349.596C382.549 338.08 361.995 309.597 349.01 301.396Z",
    fill: "url(#paint24_radial)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M349.01 301.396C332.603 291.036 329.15 276.355 315.336 255.631C301.523 234.908 280.799 229.296 280.799 229.296C279.45 220.123 284.326 203.77 288.176 192.793L277.778 187.848C277.778 187.848 276.853 187.902 275.4 188.195L275.188 188.28L263.625 194.154C259.771 197.9 256.811 203.858 257.485 213.32C259.212 237.498 295.908 250.016 295.908 250.016C295.908 250.016 298.929 251.311 309.289 268.581C319.649 285.852 379.662 348.883 380.094 351.473C380.526 354.063 379.662 354.495 382.684 355.79C384.133 356.41 387.475 353.153 390.558 349.596C382.549 338.08 361.995 309.597 349.01 301.396Z",
    fill: "url(#paint25_radial)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M419.919 200.964C419.919 200.964 437.082 199.507 439.672 200.37C439.672 200.37 440.103 199.075 436.65 197.349C433.197 195.622 426.722 196.485 426.722 196.485L418.52 196.917L419.919 200.964Z",
    fill: "url(#paint26_radial)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M335.197 194.327C335.197 194.327 334.334 196.485 337.355 198.212C340.377 199.939 362.396 205.982 396.07 203.392C396.07 203.392 413.772 200.37 416.362 201.234C416.362 201.234 425.858 190.442 427.153 190.442C428.448 190.442 422.405 188.284 415.498 196.485L403.412 198.644H388.731L383.12 196.917C383.12 196.917 361.101 191.737 346.856 180.941C332.603 170.15 335.197 194.327 335.197 194.327Z",
    fill: "#FFDE99"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M335.197 194.327C335.197 194.327 334.334 196.485 337.355 198.212C340.377 199.939 362.396 205.982 396.07 203.392C396.07 203.392 413.772 200.37 416.362 201.234C416.362 201.234 425.858 190.442 427.153 190.442C428.448 190.442 422.405 188.284 415.498 196.485L403.412 198.644H388.731L383.12 196.917C383.12 196.917 361.101 191.737 346.856 180.941C332.603 170.15 335.197 194.327 335.197 194.327Z",
    fill: "url(#paint27_radial)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M339.945 133.886C339.945 133.886 345.557 169.718 344.693 174.467C344.693 174.467 347.715 173.172 348.578 174.467C349.442 175.762 348.578 177.92 348.578 177.92L350.737 180.942C350.737 180.942 337.355 196.485 335.193 196.485C333.744 196.485 331.516 193.371 330.205 191.325C329.662 190.473 329.566 189.398 330.017 188.496C330.252 188.026 330.444 187.386 330.444 186.557C330.444 184.399 325.264 176.197 324.401 151.157C323.538 126.112 339.945 133.886 339.945 133.886Z",
    fill: "#F1D23C"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M339.945 133.886C339.945 133.886 345.557 169.718 344.693 174.467C344.693 174.467 347.715 173.172 348.578 174.467C349.442 175.762 348.578 177.92 348.578 177.92L350.737 180.942C350.737 180.942 337.355 196.485 335.193 196.485C333.744 196.485 331.516 193.371 330.205 191.325C329.662 190.473 329.566 189.398 330.017 188.496C330.252 188.026 330.444 187.386 330.444 186.557C330.444 184.399 325.264 176.197 324.401 151.157C323.538 126.112 339.945 133.886 339.945 133.886Z",
    fill: "url(#paint28_radial)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M336.492 136.908C336.492 136.908 323.769 177.033 318.358 187.852C315.336 193.895 309.293 200.37 309.293 200.37C302.818 201.665 286.842 193.895 286.842 193.895L304.113 152.879L336.492 136.908Z",
    fill: "#272163"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M350.737 103.666C350.737 103.666 345.557 107.551 339.082 123.094L333.038 117.483L328.722 111.008L327.858 106.259C327.858 106.259 339.082 98.9211 337.787 87.6939C336.492 76.4667 358.075 88.985 350.737 103.666Z",
    fill: "#FFDE99"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M350.737 103.666C350.737 103.666 345.557 107.551 339.082 123.094L333.038 117.483L328.722 111.008L327.858 106.259C327.858 106.259 339.082 98.9211 337.787 87.6939C336.492 76.4667 358.075 88.985 350.737 103.666Z",
    fill: "url(#paint29_radial)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M361.96 69.5559C361.96 69.5559 362.823 103.23 357.212 107.978C357.212 107.978 348.578 108.41 344.693 104.525C339.513 99.3448 338.218 93.7331 338.218 93.7331V88.5531L330.448 85.5314L326.995 74.7398L332.607 68.2648L348.151 66.1064L358.079 66.5381L361.96 69.5559Z",
    fill: "#FFDE99"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M361.96 69.5559C361.96 69.5559 362.823 103.23 357.212 107.978C357.212 107.978 348.578 108.41 344.693 104.525C339.513 99.3448 338.218 93.7331 338.218 93.7331V88.5531L330.448 85.5314L326.995 74.7398L332.607 68.2648L348.151 66.1064L358.079 66.5381L361.96 69.5559Z",
    fill: "url(#paint30_radial)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M359.713 102.756C360.808 98.5512 361.39 92.6197 361.694 86.9309C358.522 83.6086 345.125 87.2624 345.125 87.2624V87.694L342.535 99.349L354.19 105.824L359.713 102.756Z",
    fill: "url(#paint31_radial)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M348.972 74.1927C349.272 72.9016 350.012 71.7376 351.099 70.9745C351.97 70.3655 352.942 70.0649 353.547 71.067C354.842 73.2253 357.863 78.837 363.907 76.247C369.95 73.657 366.065 65.0237 366.065 65.0237C366.065 65.0237 369.087 68.9087 367.792 71.4987C367.792 71.4987 373.835 65.887 368.223 57.2498C362.612 48.6126 354.842 62.4298 352.248 57.2498C349.654 52.0698 345.341 49.0481 341.456 52.5015C337.571 55.9548 338.003 57.2498 338.003 57.2498C338.003 57.2498 338.866 53.7965 335.413 54.2281C331.959 54.6598 330.233 55.9548 325.916 54.6598C321.599 53.3648 312.099 55.5231 317.283 69.772C322.463 84.0208 328.506 84.4525 327.211 87.0425C325.916 89.6325 323.758 94.8125 331.096 94.3808C338.434 93.9492 337.737 91.6714 337.737 91.6714L338.434 88.7692C338.434 88.7692 331.959 86.6108 335.844 81.4308C339.729 76.2508 341.888 81.4308 341.888 81.4308C341.888 81.4308 346.204 77.5458 347.931 72.3658C347.931 72.3658 346.204 79.2725 344.046 80.9992C344.046 80.9992 347.731 79.523 348.972 74.1927Z",
    fill: "#241921"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M348.972 74.1927C349.272 72.9016 350.012 71.7376 351.099 70.9745C351.97 70.3655 352.942 70.0649 353.547 71.067C354.842 73.2253 357.863 78.837 363.907 76.247C369.95 73.657 366.065 65.0237 366.065 65.0237C366.065 65.0237 369.087 68.9087 367.792 71.4987C367.792 71.4987 373.835 65.887 368.223 57.2498C362.612 48.6126 354.842 62.4298 352.248 57.2498C349.654 52.0698 345.341 49.0481 341.456 52.5015C337.571 55.9548 338.003 57.2498 338.003 57.2498C338.003 57.2498 338.866 53.7965 335.413 54.2281C331.959 54.6598 330.233 55.9548 325.916 54.6598C321.599 53.3648 312.099 55.5231 317.283 69.772C322.463 84.0208 328.506 84.4525 327.211 87.0425C325.916 89.6325 323.758 94.8125 331.096 94.3808C338.434 93.9492 337.737 91.6714 337.737 91.6714L338.434 88.7692C338.434 88.7692 331.959 86.6108 335.844 81.4308C339.729 76.2508 341.888 81.4308 341.888 81.4308C341.888 81.4308 346.204 77.5458 347.931 72.3658C347.931 72.3658 346.204 79.2725 344.046 80.9992C344.046 80.9992 347.731 79.523 348.972 74.1927Z",
    fill: "url(#paint32_radial)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M341.24 115.752C341.24 115.752 334.765 112.731 332.175 105.392C329.585 98.0539 323.11 97.1906 323.11 97.1906C323.11 97.1906 321.384 96.7589 322.247 100.212C323.11 103.666 320.952 109.277 312.75 110.572C304.549 111.867 251.014 121.796 243.672 134.749C243.672 134.749 241.514 129.138 240.65 135.613V140.361C240.65 140.361 238.06 136.476 237.629 140.361C237.197 144.246 239.787 144.678 239.787 144.678L241.082 143.383C241.082 143.383 258.353 151.584 256.626 156.764C256.626 156.764 259.216 158.923 259.648 153.311C259.648 153.311 260.079 155.038 263.533 153.743L263.964 151.584C263.964 151.584 276.051 149.426 282.961 148.994C282.961 148.994 268.713 169.718 263.533 172.74C258.353 175.762 228.995 198.644 228.995 198.644L189.702 221.526C189.702 221.526 206.973 247.43 210.426 247.862L216.901 243.977C216.901 243.977 223.376 247.862 227.261 254.768C231.146 261.675 240.643 271.607 258.345 270.744C258.345 270.744 254.46 250.02 275.615 212.893C296.771 175.765 326.128 156.764 336.924 140.793C347.715 124.817 346.852 117.479 346.852 117.479L341.24 115.752Z",
    fill: "#FEC100"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M341.24 115.752C341.24 115.752 334.765 112.731 332.175 105.392C329.585 98.0539 323.11 97.1906 323.11 97.1906C323.11 97.1906 321.384 96.7589 322.247 100.212C323.11 103.666 320.952 109.277 312.75 110.572C304.549 111.867 251.014 121.796 243.672 134.749C243.672 134.749 241.514 129.138 240.65 135.613V140.361C240.65 140.361 238.06 136.476 237.629 140.361C237.197 144.246 239.787 145.109 239.787 145.109L240.65 143.814C240.65 143.814 258.353 151.584 256.626 156.764C256.626 156.764 259.216 158.923 259.648 153.311C259.648 153.311 260.079 155.038 263.533 153.743L263.964 151.584C263.964 151.584 276.051 149.426 282.961 148.994C282.961 148.994 268.713 169.718 263.533 172.74C258.353 175.762 228.995 198.644 228.995 198.644L189.702 221.526C189.702 221.526 206.973 247.43 210.426 247.862L216.901 243.977C216.901 243.977 223.376 247.862 227.261 254.768C231.146 261.675 240.643 271.607 258.345 270.744C258.345 270.744 254.46 250.02 275.615 212.893C296.771 175.765 326.128 156.764 336.924 140.793C347.715 124.817 346.852 117.479 346.852 117.479L341.24 115.752Z",
    fill: "url(#paint33_radial)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M346.852 117.479L341.241 115.752C341.241 115.752 334.766 112.731 332.176 105.392C329.586 98.0539 323.111 97.1906 323.111 97.1906C323.111 97.1906 321.384 96.7589 322.247 100.212C323.111 103.666 320.952 109.277 312.751 110.572C310.85 110.873 306.522 111.636 300.903 112.792C301.061 115.791 301.277 118.789 301.57 121.78C303.084 137.301 306.792 152.286 312.662 166.419C322.96 156.233 331.933 148.189 336.932 140.793C347.716 124.817 346.852 117.479 346.852 117.479Z",
    fill: "url(#paint34_radial)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M155.812 194.543C155.812 194.543 204.599 184.183 244.316 207.493C250.132 210.908 299.145 258.869 406.213 288.226C449.492 300.093 560.773 315.857 560.773 315.857",
    stroke: "#0144B9",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M256.622 157.196C256.622 157.196 239.552 184.761 235.998 193.645C235.998 193.645 241.945 196.917 243.24 198.644C244.535 200.37 247.125 206.845 251.442 208.572C251.442 208.572 248.42 211.162 246.262 209.435C244.104 207.709 244.104 207.709 244.104 207.709L246.262 210.299C246.262 210.299 243.672 213.752 241.945 213.32C240.219 212.889 240.65 213.752 238.492 213.32C236.334 212.889 235.039 211.594 235.039 211.594C235.039 211.594 235.039 212.889 233.744 212.457C232.745 212.126 228.429 207.293 226.49 204.679C225.889 203.87 225.689 202.829 225.943 201.854L228.132 193.46C228.132 193.46 230.722 158.491 240.65 143.811C240.647 143.814 259.644 149.858 256.622 157.196Z",
    fill: "#FFDE99"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M256.622 157.196C256.622 157.196 239.552 184.761 235.998 193.645C235.998 193.645 241.945 196.917 243.24 198.644C244.535 200.37 247.125 206.845 251.442 208.572C251.442 208.572 248.42 211.162 246.262 209.435C244.104 207.709 244.104 207.709 244.104 207.709L246.262 210.299C246.262 210.299 243.672 213.752 241.945 213.32C240.219 212.889 240.65 213.752 238.492 213.32C236.334 212.889 235.039 211.594 235.039 211.594C235.039 211.594 235.039 212.889 233.744 212.457C232.745 212.126 228.429 207.293 226.49 204.679C225.889 203.87 225.689 202.829 225.943 201.854L228.132 193.46C228.132 193.46 230.722 158.491 240.65 143.811C240.647 143.814 259.644 149.858 256.622 157.196Z",
    fill: "url(#paint35_radial)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M448.983 198.759H348.204C347.395 198.759 346.74 198.104 346.74 197.295V196.944C346.74 196.135 347.395 195.479 348.204 195.479H448.983C449.792 195.479 450.448 196.135 450.448 196.944V197.295C450.448 198.1 449.792 198.759 448.983 198.759Z",
    fill: "#241921"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M448.983 198.759H389.251C388.442 198.759 387.787 198.104 387.787 197.295V196.944C387.787 196.135 388.442 195.479 389.251 195.479H448.983C449.792 195.479 450.448 196.135 450.448 196.944V197.295C450.448 198.1 449.792 198.759 448.983 198.759Z",
    fill: "#272163"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M464.604 144.03H405.805C405.011 144.03 404.31 144.539 404.063 145.291L388.581 192.242C388.188 193.429 389.074 194.655 390.323 194.655H449.122C449.916 194.655 450.618 194.146 450.864 193.394L466.347 146.443C466.74 145.252 465.853 144.03 464.604 144.03Z",
    fill: "#272163"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M380.88 197.939H376.082C375.742 197.939 375.473 197.665 375.473 197.33V197.183C375.473 196.844 375.746 196.574 376.082 196.574H380.88C381.219 196.574 381.489 196.848 381.489 197.183V197.33C381.493 197.665 381.219 197.939 380.88 197.939Z",
    stroke: "#7FD2F6",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M446.416 198.073H441.618C441.279 198.073 441.009 197.8 441.009 197.464V197.318C441.009 196.979 441.282 196.709 441.618 196.709H446.416C446.755 196.709 447.025 196.983 447.025 197.318V197.464C447.029 197.8 446.755 198.073 446.416 198.073Z",
    stroke: "#7FD2F6",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M370.894 198.073H366.096C365.757 198.073 365.487 197.8 365.487 197.464V197.318C365.487 196.979 365.76 196.709 366.096 196.709H370.894C371.233 196.709 371.503 196.983 371.503 197.318V197.464C371.503 197.8 371.23 198.073 370.894 198.073Z",
    stroke: "#7FD2F6",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M384.576 198.073H384.43C384.091 198.073 383.821 197.8 383.821 197.464V197.318C383.821 196.979 384.094 196.709 384.43 196.709H384.576C384.915 196.709 385.185 196.983 385.185 197.318V197.464C385.185 197.8 384.912 198.073 384.576 198.073Z",
    stroke: "#7FD2F6",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M465.683 144.381C465.383 144.161 465.013 144.03 464.604 144.03H405.805C405.011 144.03 404.309 144.539 404.063 145.291L388.762 191.691L465.683 144.381Z",
    fill: "url(#paint36_linear)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M455.801 147.615L437.193 159.108",
    stroke: "white",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M413.768 201.666L423.846 200.517C423.846 200.517 430.41 192.94 433.744 191.691C433.744 191.691 431.466 189.579 426.286 193.896C421.106 198.212 421.538 197.781 421.538 197.781H415.926L413.768 201.666Z",
    fill: "#FFDE99"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M413.768 201.666L423.846 200.517C423.846 200.517 430.41 192.94 433.744 191.691C433.744 191.691 431.466 189.579 426.286 193.896C421.106 198.212 421.538 197.781 421.538 197.781H415.926L413.768 201.666Z",
    fill: "url(#paint37_radial)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M415.495 196.486L403.408 198.644H403.327C401.103 198.644 398.902 199.072 396.817 199.846C393.121 201.222 386.48 202.583 385.178 203.955C388.654 203.862 392.285 203.681 396.066 203.392C396.066 203.392 412.041 202.097 416.358 201.234C416.358 201.234 425.855 190.442 427.15 190.442C428.445 190.442 422.405 188.284 415.495 196.486Z",
    fill: "#FFDE99"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M216.901 243.976C216.901 243.976 210.857 238.796 210.426 242.25C209.994 245.703 211.289 247.43 210.426 247.861L216.901 243.976Z",
    fill: "url(#paint38_radial)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M211.274 241.063L211.301 241.097C213.085 240.708 216.897 243.976 216.897 243.976C216.897 243.976 223.372 247.861 227.257 254.768C228.036 256.155 229.049 257.662 230.302 259.185L257.52 207.712L211.274 241.063Z",
    fill: "url(#paint39_radial)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M246.259 210.299L244.459 208.141C244.459 208.141 241.51 205.551 241.51 202.961C241.51 200.837 232.8 205.678 226.807 205.107C228.865 207.786 232.792 212.145 233.736 212.461C235.031 212.893 235.031 211.598 235.031 211.598C235.031 211.598 236.326 212.893 238.485 213.324C240.643 213.756 240.211 212.893 241.938 213.324C243.669 213.756 246.259 210.299 246.259 210.299Z",
    fill: "url(#paint40_radial)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M341.024 119.421C341.024 119.421 340.161 134.102 314.65 157.319",
    stroke: "white",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M347.499 67.6138C347.499 67.6138 346.204 74.5204 341.024 77.9738",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M344.478 69.3403C344.478 69.3403 342.319 74.952 334.118 78.837",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M394.775 340.25C394.775 340.25 389.595 349.315 383.12 353.2",
    stroke: "#DEF4FF",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M176.104 261.891C176.104 261.891 177.195 254.63 182.048 251.138",
    stroke: "#DEF4FF",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2104 281.724C75.291 284.256 75.3681 288.107 77.3915 290.558C79.7271 293.387 83.9667 294.138 86.1713 297.068C87.8517 299.299 87.925 302.61 86.3447 304.915",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M629.385 264.588C630.981 264.588 632.276 263.294 632.276 261.698C632.276 260.101 630.981 258.807 629.385 258.807C627.79 258.807 626.495 260.101 626.495 261.698C626.495 263.294 627.79 264.588 629.385 264.588Z",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M127.578 148.911L123.856 149.912L124.858 153.634L128.579 152.632L127.578 148.911Z",
    stroke: "#FA404B",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M433.401 240.307C433.401 240.307 447.276 224.891 467.318 233.37",
    stroke: "#FA404B",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M158.984 296.578L152.817 305.828",
    stroke: "#FA404B",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M210.63 64.1719L216.411 68.4115",
    stroke: "#FA404B",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M579.99 205.258C584.465 206.337 589.522 204.263 591.954 200.351C592.844 198.918 593.399 197.291 594.297 195.857C595.954 193.217 598.802 191.356 601.886 190.897",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.613 79.3432) scale(389.101)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02EED2",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(601.358 371.058) scale(49.7762)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3231,
    stopColor: "#C184A8",
    stopOpacity: 0.2102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9171,
    stopColor: "#0061FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(597.269 360.096) scale(21.1174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1043,
    stopColor: "#FFDE99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#FFDE99",
    stopOpacity: 0.9985
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#E9BD9E",
    stopOpacity: 0.8173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4348,
    stopColor: "#D7A4A3",
    stopOpacity: 0.6311
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#CB92A6",
    stopOpacity: 0.4371
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    stopColor: "#C387A7",
    stopOpacity: 0.2326
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C184A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(526.81 383.983) scale(55.273)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3231,
    stopColor: "#C184A8",
    stopOpacity: 0.2102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9171,
    stopColor: "#0061FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(528.391 369.749) scale(35.7736)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1043,
    stopColor: "#FFDE99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#FFDE99",
    stopOpacity: 0.9985
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#E9BD9E",
    stopOpacity: 0.8173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4348,
    stopColor: "#D7A4A3",
    stopOpacity: 0.6311
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#CB92A6",
    stopOpacity: 0.4371
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    stopColor: "#C387A7",
    stopOpacity: 0.2326
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C184A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(574.444 307.007) scale(29.5373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3231,
    stopColor: "#C184A8",
    stopOpacity: 0.2102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9171,
    stopColor: "#0061FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(558.546 347.645) rotate(-12.7855) scale(170.166 62.1739)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3231,
    stopColor: "#C18484",
    stopOpacity: 0.2102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9171,
    stopColor: "#272163"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(499.268 367.949) scale(34.1773)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1043,
    stopColor: "#FFDE99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#FFDE99",
    stopOpacity: 0.9985
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#E9BD9E",
    stopOpacity: 0.8173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4348,
    stopColor: "#D7A4A3",
    stopOpacity: 0.6311
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#CB92A6",
    stopOpacity: 0.4371
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    stopColor: "#C387A7",
    stopOpacity: 0.2326
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C184A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(575.674 368.44) scale(21.4095)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1043,
    stopColor: "#FFDE99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#FFDE99",
    stopOpacity: 0.9985
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#E9BD9E",
    stopOpacity: 0.8173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4348,
    stopColor: "#D7A4A3",
    stopOpacity: 0.6311
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#CB92A6",
    stopOpacity: 0.4371
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    stopColor: "#C387A7",
    stopOpacity: 0.2326
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C184A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(603.944 327.275) rotate(-17.4873) scale(49.4963 33.3164)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1043,
    stopColor: "#FFDE99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#FFDE99",
    stopOpacity: 0.9985
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#E9BD9E",
    stopOpacity: 0.8173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4348,
    stopColor: "#D7A4A3",
    stopOpacity: 0.6311
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#CB92A6",
    stopOpacity: 0.4371
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    stopColor: "#C387A7",
    stopOpacity: 0.2326
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C184A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(582.869 335.556) scale(26.9334)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0175,
    stopColor: "#1B66F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0482,
    stopColor: "#466EDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0825,
    stopColor: "#6C75CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1196,
    stopColor: "#8D7BBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1604,
    stopColor: "#A980B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2062,
    stopColor: "#C084A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2592,
    stopColor: "#D187A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3238,
    stopColor: "#DD899C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4126,
    stopColor: "#E48B99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#E68B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8F8F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(596.818 310.402) scale(7.22501)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0144B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0286,
    stopColor: "#0C47B7",
    stopOpacity: 0.9606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2403,
    stopColor: "#5C5FAA",
    stopOpacity: 0.6686
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3908,
    stopColor: "#8E6EA1",
    stopOpacity: 0.4611
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4648,
    stopColor: "#A1749E",
    stopOpacity: 0.3591
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4868,
    stopColor: "#A7769D",
    stopOpacity: 0.3443
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6368,
    stopColor: "#CB8197",
    stopOpacity: 0.2437
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7768,
    stopColor: "#E68993",
    stopOpacity: 0.1497
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9021,
    stopColor: "#F58D90",
    stopOpacity: 0.0657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8F8F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(627.477 333.374) scale(22.0834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3176,
    stopColor: "#FB8F8F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3846,
    stopColor: "#F58D90",
    stopOpacity: 0.0982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4703,
    stopColor: "#E58993",
    stopOpacity: 0.2238
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#CB8197",
    stopOpacity: 0.3644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    stopColor: "#A6769D",
    stopOpacity: 0.5158
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#7768A5",
    stopOpacity: 0.6762
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8915,
    stopColor: "#3F57AF",
    stopOpacity: 0.8411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0144B9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(598.741 319.605) scale(9.58542 9.58557)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3176,
    stopColor: "#FB8F8F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3846,
    stopColor: "#F58D90",
    stopOpacity: 0.0982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4703,
    stopColor: "#E58993",
    stopOpacity: 0.2238
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#CB8197",
    stopOpacity: 0.3644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    stopColor: "#A6769D",
    stopOpacity: 0.5158
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#7768A5",
    stopOpacity: 0.6762
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8915,
    stopColor: "#3F57AF",
    stopOpacity: 0.8411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0144B9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(595.854 316.555) rotate(102.088) scale(11.7789 6.22196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3176,
    stopColor: "#FB8F8F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3846,
    stopColor: "#F58D90",
    stopOpacity: 0.0982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4703,
    stopColor: "#E58993",
    stopOpacity: 0.2238
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#CB8197",
    stopOpacity: 0.3644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    stopColor: "#A6769D",
    stopOpacity: 0.5158
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#7768A5",
    stopOpacity: 0.6762
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8915,
    stopColor: "#3F57AF",
    stopOpacity: 0.8411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0144B9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(537.39 366.859) scale(57.6699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3231,
    stopColor: "#C184A8",
    stopOpacity: 0.2102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9171,
    stopColor: "#0061FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(465.352 76.7143) scale(160.667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0281,
    stopColor: "#106CFE",
    stopOpacity: 0.9719
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1219,
    stopColor: "#408BFE",
    stopOpacity: 0.8781
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2211,
    stopColor: "#6AA7FE",
    stopOpacity: 0.7789
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3241,
    stopColor: "#8EBFFF",
    stopOpacity: 0.6759
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4318,
    stopColor: "#ABD2FF",
    stopOpacity: 0.5682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#C2E1FF",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    stopColor: "#D2ECFF",
    stopOpacity: 0.3304
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8094,
    stopColor: "#DBF2FF",
    stopOpacity: 0.1906
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEF4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(468.081 95.6078) scale(32.7946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C1DA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(472.366 85.4411) scale(50.5825)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C1DA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(477.184 80.238) scale(50.5825)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C1DA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(465.51 118.773) scale(119.008 78.1556)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0281,
    stopColor: "#106CFE",
    stopOpacity: 0.9719
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1219,
    stopColor: "#408BFE",
    stopOpacity: 0.8781
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2211,
    stopColor: "#6AA7FE",
    stopOpacity: 0.7789
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3241,
    stopColor: "#8EBFFF",
    stopOpacity: 0.6759
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4318,
    stopColor: "#ABD2FF",
    stopOpacity: 0.5682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#C2E1FF",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    stopColor: "#D2ECFF",
    stopOpacity: 0.3304
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8094,
    stopColor: "#DBF2FF",
    stopOpacity: 0.1906
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEF4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(465.51 125.325) scale(119.008 78.1556)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0281,
    stopColor: "#106CFE",
    stopOpacity: 0.9719
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1219,
    stopColor: "#408BFE",
    stopOpacity: 0.8781
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2211,
    stopColor: "#6AA7FE",
    stopOpacity: 0.7789
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3241,
    stopColor: "#8EBFFF",
    stopOpacity: 0.6759
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4318,
    stopColor: "#ABD2FF",
    stopOpacity: 0.5682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#C2E1FF",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    stopColor: "#D2ECFF",
    stopOpacity: 0.3304
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8094,
    stopColor: "#DBF2FF",
    stopOpacity: 0.1906
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEF4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.775 232.596) scale(53.7383)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(382.294 357.806) scale(36.4914)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.295 170.318) scale(176.629)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00534759,
    stopColor: "#241921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(323.07 373.839) scale(108.216)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00534759,
    stopColor: "#241921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0061FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(417.961 194.695) scale(23.1785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(376.496 197.08) rotate(4.60567) scale(21.97 10.5904)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(317.835 135.634) scale(99.1647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C1DA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(351.373 108.149) scale(24.7175)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331.468 75.5376) scale(32.2111)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(359.608 79.4642) scale(24.0173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(393.202 70.3023) scale(68.6385)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    stopColor: "#241921"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(226.218 141.524) scale(117.876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C1DA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(352.192 115.348) scale(58.8651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D23C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(223.273 135.525) scale(65.2931)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 442.08,
    y1: 98.5742,
    x2: 423.322,
    y2: 186.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1791,
    stopColor: "#272163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EECFF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(417.225 196.822) scale(9.19815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.707 241.369) scale(14.9855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C1DA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(213.13 232.65) scale(29.7202)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D23C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(231.126 201.948) scale(15.4404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA404B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#FA484F",
    stopOpacity: 0.975
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1916,
    stopColor: "#FC7565",
    stopOpacity: 0.8084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3589,
    stopColor: "#FD9B78",
    stopOpacity: 0.6411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5244,
    stopColor: "#FEB886",
    stopOpacity: 0.4756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6876,
    stopColor: "#FECD91",
    stopOpacity: 0.3124
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8474,
    stopColor: "#FFDA97",
    stopOpacity: 0.1526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE99",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotFound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/not-found.8b143bad.svg";
export { ForwardRef as ReactComponent };